import { render, staticRenderFns } from "./SobreNos.vue?vue&type=template&id=3ac9eabe&"
import script from "./SobreNos.vue?vue&type=script&lang=ts&"
export * from "./SobreNos.vue?vue&type=script&lang=ts&"
import style0 from "./SobreNos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
